import Handlebars from 'handlebars';

interface Block {
  id: string;
  name: string;
  type: string;
  partial: string;
}

interface PartialInfo {
  id: string;
  name: string;
  type: string;
}

const normalizePartialName = (name: string): string =>
  name
    .trim()
    .replace(/^\[|\]$/g, '')
    .replace(/^["']|["']$/g, '');

const removeDuplicatesById = (arr: PartialInfo[]): PartialInfo[] => {
  const seenIds = new Set<string>();
  const result: PartialInfo[] = [];

  for (const item of arr) {
    if (!seenIds.has(item.id)) {
      seenIds.add(item.id);
      result.push(item);
    }
  }

  return result;
};
export const handlebarsToPartialsWIthIds = (mainTemplate: string, allBlocks: Block[]): PartialInfo[] => {
  const blockAstMap = new Map<string, any>();
  const blockInfoMap = new Map<string, PartialInfo>();

  for (const block of allBlocks) {
    try {
      const ast = Handlebars.parse(block.partial);
      blockAstMap.set(block.name, ast);
      blockInfoMap.set(block.name, {
        id: block.id,
        name: block.name,
        type: block.type,
      });
    } catch (error) {
      console.error(`Error parsing partial "${block.name}":`, error);
    }
  }

  let mainAst;
  try {
    mainAst = Handlebars.parse(mainTemplate);
  } catch (error) {
    console.error('Error parsing main template:', error);
    return [];
  }

  const partialsUsed = new Map<string, PartialInfo>();
  const addedIds = new Set<string>();
  const visitedTemplates = new Set<string>();

  const visit = (node: any, isRoot = false) => {
    if (!node || typeof node !== 'object') return;

    switch (node.type) {
      case 'PartialStatement': {
        const rawName = node.name.original;
        const name = normalizePartialName(rawName);

        // Skip Handlebars built-in partials
        if (name === '@partial-block') {
          break;
        }

        if (!visitedTemplates.has(name)) {
          visitedTemplates.add(name);

          const info = blockInfoMap.get(name);
          if (!info) {
            console.error(`Partial "${name}" not found in allBlocks`);
            break;
          }

          // Only add if not root or not added yet
          if (!isRoot && !addedIds.has(info.id)) {
            partialsUsed.set(name, info);
            addedIds.add(info.id);
          }

          const partialAst = blockAstMap.get(name);
          if (partialAst) visit(partialAst);
        }
        break;
      }

      case 'PartialBlockStatement': {
        const rawName = node.name.original;
        const name = normalizePartialName(rawName);

        // Skip Handlebars built-in partials
        if (name === '@partial-block') {
          break;
        }

        if (!visitedTemplates.has(name)) {
          visitedTemplates.add(name);

          const info = blockInfoMap.get(name);
          if (!info) {
            console.error(`Partial block "${name}" not found in allBlocks`);
            break;
          }

          if (!isRoot && !addedIds.has(info.id)) {
            partialsUsed.set(name, info);
            addedIds.add(info.id);
          }

          const partialAst = blockAstMap.get(name);
          if (partialAst) visit(partialAst);
        }

        if (node.program) visit(node.program);
        break;
      }

      case 'BlockStatement': {
        if (node.program) visit(node.program);
        if (node.inverse) visit(node.inverse);
        break;
      }

      case 'Program': {
        for (const child of node.body) visit(child);
        break;
      }

      default: {
        for (const key in node) {
          const value = node[key];
          if (Array.isArray(value)) value.forEach((v) => visit(v));
          else if (typeof value === 'object' && value !== null) visit(value);
        }
      }
    }
  };

  visit(mainAst);

  // Fixme: there is duplicated layout entry...
  return Array.from(partialsUsed.values());
};
